
export default class FormEmpresa {
    constructor() {
        this.form = this.form();
    }

    form() {
        return {
            fechar: false,
            items: [
                { type: 'T', text: "CNPJ/CPF", item_id: 'cnpj', valor: null, prepIcon: 'location_city', class: "input-required", mask: '', maskCPF:{ v: "###.###.###-##", b: false }, maskCNPJ: {v : "##.###.###/####-##", b: false}},
                { type: 'T', text: "Razão Social", item_id: 'razao', valor: null, prepIcon: 'location_city', class: "input-required", mask: null },
                { type: 'T', text: "Grupo", item_id: 'grupo', valor: null, prepIcon: 'location_city', class: null, mask: null },
                { type: 'T', text: "Apelido", item_id: 'apelido', valor: null, prepIcon: 'location_city', class: null, mask: null },
                { type: 'T', text: "CCM", item_id: 'ccm', valor: null, prepIcon: 'location_city', class: null, mask: null },
                { type: 'T', text: "IE", item_id: 'ie', valor: null, prepIcon: 'location_city', class: null, mask: null },
                { type: 'T', text: "CEP", item_id: 'cep', valor: null, prepIcon: 'place', class: null, mask: "#####-###" },
                // { type: 'S', text: "Faturamento", item_id: 'faturamento', prepIcon: 'attach_money', valor: null, options: ['Sim', 'Não'], multiple: false },
                { type: 'T', text: "Endereço", item_id: 'endereco', valor: null, prepIcon: 'place', class: null, mask: null },
                { type: 'T', text: "Bairro", item_id: 'bairro', valor: null, prepIcon: 'place', class: null, mask: null },
                { type: 'T', text: "Complemento", item_id: 'complemento', valor: null, prepIcon: 'place', class: null, mask: null },
            ]
        };
    }

    isValidCNPJ(v) {
        var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        if ((v = v.replace(/[^\d]/g, "")).length != 14) return "CNPJ inválido";

        if (/0{14}/.test(v)) return "CNPJ inválido";

        for (var i = 0, n = 0; i < 12; n += v[i] * b[++i]);
        if (v[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        for (var i = 0, n = 0; i <= 12; n += v[i] * b[i++]);
        if (v[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return "CNPJ inválido";

        return true;
    }

}





// WEBPACK FOOTER //
// ./src/domain/conta/empresa/FormEmpresa.js